import moment from "moment";
import adverseEffectsWageRatesResolver from "./helper.js";
import h2bUtils from "../../../global/utils/9142BHelper";
import { wageMultiplier, rateMapper } from "../utils/wageUtils";
// import Util from "../../../global/utils/Helpers";

// For checking a single value
//Use this format
// isVisible: {
//     when: 'h4_exemption_basis',
//     is: ['Master\'s Degree or higher in related speciality'],
//     operator: 'compareMultiFieldValues',
// }
//is must be an array
function condition(whenArray, is, formApi) {
  for (let i = 0; i < whenArray.length; i++) {
    if (formApi.getState().values[whenArray[i]] !== is[i]) {
      return false;
    }
  }
  return true;
}

function conditionOR(whenArray, is, formApi) {
  let ret = [];
  let isValue, curr_value;

  whenArray.map((when) => {
    if (is === "undefined") {
      isValue = undefined;
    } else {
      isValue = is;
    }
    curr_value = formApi.getState().values[when];
    if (curr_value !== isValue) {
      ret.push(false);
    } else {
      ret.push(isValue === undefined ? "undefined" : curr_value);
    }
  });
  return ret.indexOf(is) > -1;
}

// this function is similar to conditionOR in that only one instance
// of the is statement is required to return 'true'
// however, this both:
// 1. takes an isArray where each index of when is compared correspondingly
// 2. will return 'false' if an element of when is equal to the notIs value
function conditionORIsArray(whenArray, isArray, formApi) {
  let ret = [];
  let isValue;
  let curr_value;

  whenArray.map((when, index) => {
    let is = isArray[index];
    let notIs = is[0] === "!";
    if (is === "undefined" || is === "!undefined") {
      isValue = undefined;
    } else {
      isValue = is;
    }
    curr_value = formApi.getState().values[when];

    // To capture null values
    if (curr_value === null) {
      curr_value = undefined;
    }
    if (notIs && curr_value == isValue) {
      ret.push("FALSE");
    } else if (curr_value !== isValue) {
      ret.push(false);
    } else {
      ret.push(isValue === undefined ? "undefined" : curr_value);
    }
  });
  // 2. element of when is === to the notIs value
  if (ret.indexOf("FALSE") > -1) {
    return false;
  }
  // regular "OR" evaluation
  if (ret.every((o) => o === false)) {
    return false;
  }
  return true;
}

function conditionDates(whenArray, isArray, formApi) {
  let when, to, difference;

  when = formApi.getState().values[whenArray[0]]
    ? moment(new Date(formApi.getState().values[whenArray[0]]))
    : undefined;
  to = formApi.getState().values[whenArray[1]]
    ? moment(new Date(formApi.getState().values[whenArray[1]]))
    : undefined;

  if (when && to) {
    difference = parseInt(when.diff(to, isArray.type));
  }
  switch (isArray.operator) {
    case ">=":
      if (difference >= parseInt(isArray.value)) {
        return true;
      }
      break;
    default:
      return false;
  }
}

function conditionAND(whenArray, is, formApi) {
  for (let i = 0; i < whenArray.length; i++) {
    if (formApi.getState().values[whenArray[i]] !== is) {
      return false;
    }
  }
  return true;
}

function conditionAndOrInArray(whenArray, is, formApi, isInlineModal) {
  for (let i = 0; i < whenArray.length; i++) {
    if (isInlineModal) {
      if (
        !is[i].includes(
          formApi.getState().values.add_values_field?.[0]?.[whenArray[i]]
        )
      ) {
        return false;
      }
    } else {
      if (!is[i].includes(formApi.getState().values[whenArray[i]])) {
        return false;
      }
    }
  }
  return true;
}

function orConditionalMultipleFields(whenArray, is, formApi) {
  /**
   * This function is basically a more robust || case operator. You could technically only have 1 field.
   *
   * This fx checks if the FIRST string in when has || (ex. machine_name||machine_name) and splits based on it.
   * Then checks if ANY of those machines have that value in the array and returns true if so.
   * This part only requires one of the machines to return true for the entire condtional array to return true.
   *
   * Additionally, if there is no || string, it can still be used to check
   * if multiple machines meet the check in multiple possible values.
   *
   * IMPORTANT NOTE: If you want to use a "machine||machine" string (optional),
   * it must be the first one in the whenArray and corresponding isArray.
   *
   * Example:
   * when: "a1_type||a1_type_a formVersionId",
   * is: [["joint", "association-joint"], [2]],
   *
   * This means if a1_type or a1_type_a are either of those values, that part returns true.
   * If the form version is also 2, the entire function returns true.
   * -----------------------------------------
   * Example:
   * when: "a1_type formVersionId",
   * is: [["joint", "association-joint"], [1]],
   *
   * This means if a1_type is either of these values in the array and form version is 1, the entire function returns true.
   *
   */
  let orArray;
  let orCheck;
  let normalCheck;

  // This first loop is to determine if there are any || strings and split again
  for (let i = 0; i < whenArray.length; i++) {
    if (whenArray[i].includes("||")) {
      orArray = whenArray[i].split("||");
    }
  }
  /**
   * This loop checks if any of the machines contain one of the values.
   * The else is in the scenario a || string was not provided so that this function still performs.
   *  */
  if (Array.isArray(orArray) && orArray.length > 0) {
    for (let x = 0; x < orArray.length; x++) {
      if (is[0].includes(formApi.getState().values[orArray[x]])) {
        orCheck = true;
      }
    }
  } else if (!Array.isArray(orArray)) {
    orCheck = true;
  }
  /**
   * Loop through the other potential machines that did not contain ||
   * If normalCheck is already false, it can not turn truthy.
   */
  for (let y = 0; y < whenArray.length; y++) {
    if (!whenArray[y].includes("||")) {
      if (
        is[y].includes(formApi.getState().values[whenArray[y]]) &&
        normalCheck !== false
      ) {
        normalCheck = true;
      } else {
        normalCheck = false;
      }
    }
  }
  return orCheck && normalCheck;
}

function conditionTwoSetsMatchAll(whenArray, is, formApi) {
  const formValues = formApi.getState();
  let showError = true;
  for (let i = 0; i < whenArray.length; i++) {
    let whenVal = formValues.values[whenArray[i]];
    let isVal = formValues.values[is[i]];
    if (whenVal !== null && isVal !== null) {
      whenVal = whenVal ? whenVal.toLowerCase().trim() : "";
      isVal = isVal ? isVal.toLowerCase().trim() : "";
      if (whenVal !== isVal) {
        showError = false;
      }
    }
  }
  return showError;
}

function conditionAndSetValue(whenArray, is, formApi) {
  let firstCondtion = false;
  let // isValue,
    curr_value;

  for (let i = 0; i < whenArray.length - 1; i++) {
    curr_value = formApi.getState().values[whenArray[i]];
    if (curr_value === is[0]) {
      firstCondtion = true;
      break;
    }
  }
  let secondCondition =
    formApi.getState().values[whenArray[whenArray.length - 1]];
  if (firstCondtion && secondCondition === is[is.length - 1]) {
    return true;
  }
}

const switchCondition = (
  when,
  is,
  operator,
  children,
  formApi,
  property,
  array,
  isInlineModal,
  modal,
  { stateAEWRS, stateAEWRHerderMonthly }
) => {
  let whenArray =
    when &&
    when != undefined &&
    !Array.isArray(when) &&
    typeof when !== "function"
      ? when.split(" ")
      : when;

  let isArray =
    is && is != undefined && typeof is === "string" ? is.split(" ") : is;
  // console.log('everything', children, when, children?.props?.children)
  switch (operator) {
    case "pwComparison":
      const pw = formApi.getState().values && formApi.getState().values[is[0]];
      const pwRate =
        formApi.getState().values && formApi.getState().values[is[1]];
      const currentRate =
        formApi.getState().values && formApi.getState().values[is[2]];
      return ({ input: { value } }) => {
        const showWarning = h2bUtils.isFromValueGreaterThanPrevailingWage(
          value,
          pw,
          pwRate,
          currentRate
        );
        return showWarning ? children : null;
      };
    case "overtimeComparison":
      const pwOvertime =
        formApi.getState().values && formApi.getState().values[is[0]];
      return ({ input: { value } }) => {
        const initialFrom = parseFloat(
          (parseFloat(pwOvertime) * 1.5).toFixed(2)
        );
        const overtimeFrom = parseFloat(value);
        const showWarning = overtimeFrom < initialFrom;
        return showWarning ? children : null;
      };
    case "minWageComparison": //is[0] = state selector and is[1] = per value and is[2] = desired value of per
      const state =
        formApi.getState().values && formApi.getState().values[is[0]];
      const per = formApi.getState().values && formApi.getState().values[is[1]];
      const perValue = is[2];
      const minWage = stateAEWRS[state] || "N/A";
      return ({ input: { value } }) =>
        parseFloat(minWage) && per === perValue
          ? parseFloat(value) < parseFloat(minWage)
            ? children
            : null
          : null;
    case "OFLCW-4407":
      let formValues = formApi.getState().values;
      const is_herder = formValues["prelim_5_is_livestock"] === "YES";
      const is_month = formValues["eta_790a_a8c_wage_offer_per"] === "month";
      const is_lessthan_aewr =
        formValues[when] !== null && formValues[when] < stateAEWRHerderMonthly;
      return () => {
        if (is_herder && is_month && is_lessthan_aewr) {
          return children;
        }
        return null;
      };
    case ">=":
      return ({ input: { value } }) => {
        // 790A date check
        if (when.includes("eta_790a_a3_begin_date")) {
          const newDate = moment(value, "YYYY-MM-DD");
          const compareDate = moment(is, "YYYY-MM-DD");
          return moment(newDate).isAfter(compareDate) ||
            moment(newDate).isSame(compareDate)
            ? children
            : null;
        }
        return parseInt(value) >= parseInt(is) ? children : null;
      };
    case "<=":
      return ({ input: { value } }) =>
        parseInt(value) <= parseInt(is) ? children : null;
    case "<":
      return ({ input: { value } }) => {
        // 790A date check
        if (when.includes("eta_790a_a3_begin_date")) {
          const newDate = moment(value, "YYYY-MM-DD");
          const compareDate = moment(is, "YYYY-MM-DD");
          return moment(newDate).isBefore(compareDate) ? children : null;
        }
        return null;
      };
    case "compareFieldValues":
      return ({ input: { value } }) =>
        value === (formApi.getFieldState(is) && formApi.getFieldState(is).value)
          ? children
          : null;
    case "compareFieldValuesModal":
      return ({ input: { value } }) => {
        const fieldArray = formApi.getState().values[modal];
        for (var i in fieldArray) {
          const field = fieldArray[i]?.[when];
          if (is.indexOf(field) > -1) return children;
        }
        return null;
      };
    case "compareMultiDateValues":
      return () => (conditionDates(whenArray, is, formApi) ? children : null);
    case "compareMultiFieldValues":
      return () => (condition(whenArray, is, formApi) ? children : null);
    case "compareMultiFieldValuesOR":
      return () => (conditionOR(whenArray, is, formApi) ? children : null);
    case "compareMultiFieldValuesOR_ISArray":
      return () =>
        conditionORIsArray(whenArray, isArray, formApi) ? children : null;
    case "compareMultiFieldValuesAND":
      return () => (conditionAND(whenArray, is, formApi) ? children : null);
    case "compareMultiFieldValuesAND_ORInArray":
      return () =>
        conditionAndOrInArray(whenArray, is, formApi, isInlineModal)
          ? children
          : null;
    case "compareMultiValuesOrConditional":
      return () =>
        orConditionalMultipleFields(whenArray, is, formApi) ? children : null;
    case "conditionTwoSetsMatchAll":
      return () =>
        conditionTwoSetsMatchAll(whenArray, is, formApi) ? children : null;
    case "conditionAndSetValue":
      return () =>
        conditionAndSetValue(whenArray, is, formApi) ? children : null;
    case "!==":
      return ({ input: { value } }) =>
        is.indexOf(value) === -1 ? children : null;
    case "||":
      return ({ input: { value } }) => {
        if (isInlineModal) {
          return is.indexOf(
            formApi.getState().values.add_values_field?.[0]?.[when]
          ) > -1
            ? children
            : null;
        } else {
          return is.indexOf(value) > -1 ? children : null;
        }
      };
    case "minCharLength":
      return ({ input: { value } }) => {
        return value?.length >= parseInt(is) ? children : null;
      };
    case "filesExist":
      return ({ input: { value } }) => {
        return value.length > 0 ? children : null;
      };
    case "untouched":
      return () =>
        formApi.getState().values[when] === null ||
        formApi.getState().values[when] === undefined
          ? children
          : null;
    case "includesCharacters":
      return ({ input: { value } }) => {
        if (value !== undefined && is && is !== undefined) {
          for (let i = 0; i < is.length; i++) {
            if (value.includes(is[i])) {
              return children;
            }
          }
        }
        return null;
      };
    case "prevailingWage200PercentCheck":
      // is[0] = prevailing_wage field, is[1] = offered_wage_per, is[2] = prevailing_wage_per
      const pw_wage = formApi.getState().values && formApi.getState().values[is[0]];
      const offered_per = formApi.getState().values && formApi.getState().values[is[1]];
      const pw_per = formApi.getState().values && formApi.getState().values[is[2]];
      
      return ({ input: { value } }) => {
        if (!value || !pw_wage || !offered_per || !pw_per) {
          return null;
        }

        const current_per = rateMapper(offered_per);
        const prevailing_per = rateMapper(pw_per);
        const offeredWage = parseFloat(value);
        const prevailingWage = parseFloat(pw_wage);

        if (isNaN(offeredWage) || isNaN(prevailingWage)) {
          return null;
        }

        let scaledOfferedWage = offeredWage;

        // Scale offered wage to match prevailing wage unit for comparison
        if (current_per !== prevailing_per) {
          scaledOfferedWage = offeredWage * wageMultiplier[`${current_per}${prevailing_per}`];
          scaledOfferedWage = Math.round(parseFloat((scaledOfferedWage * Math.pow(10, 2)).toFixed(2))) / Math.pow(10, 2);
        }

        // Check if offered wage is >= 200% MORE THAN prevailing wage (+200% = 3x)
        const showWarning = scaledOfferedWage >= (prevailingWage * 3.0);
        return showWarning ? children : null;
      };
    case "any":
      return () => {
        let showWarning = false;
        if (array && is && when && property) {
          let section_f = formApi.getState().values[when];

          if (section_f && property) {
            section_f.forEach((item) => {
              if (Array.isArray(is)) {
                if (is.includes(item[property])) {
                  showWarning = true;
                }
              } else {
                if (is === item[property]) {
                  showWarning = true;
                }
              }
            });
          }
        }
        return showWarning ? children : null;
      };
    case "has_value":
      return ({ input: { value } }) => {
        const valueToCompare = isInlineModal
          ? formApi.getState().values.add_values_field?.[0]?.[when]
          : value;
        return !!valueToCompare ? children : null;
      };
    case "has_value_and_not_na":
      return ({ input: { value } }) => {
        const na_regex = /^[Nn]\/[Aa]$/;
        const valueToCompare = isInlineModal
          ? formApi.getState().values.add_values_field?.[0]?.[when]
          : value;
        return !!valueToCompare && !valueToCompare.match(na_regex)
          ? children
          : null;
      };
    case "customValidation":
      return () => {
        return when(formApi) ? children : null;
      };
    default:
      return ({ input: { value } }) => {
        // console.log(when, 'val = ',value,'children = ', children)
        return value === is || (Array.isArray(value) && value.indexOf(is) > -1)
          ? children
          : null;
      };
  }
};

export default switchCondition;
